import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ReservationReturn } from '../clients/rust-api-client';
import { memberReservationService } from '../clients/ApiClients';
import { Subheading } from '../Components/Catalyst/heading';
import { Text } from '../Components/Catalyst/text';
import { useMember } from '../Hooks/MemberContext';
import ReservationRow from './ReservationRow';

const SHOWN = 3;

/**
 * The dashboard's next few bookings for the selected home. Quiet on
 * failure — the dashboard is not the place to report that this one
 * read went wrong; the reservations page is.
 */
const UpcomingReservationsCard: React.FC = () => {
  const { selectedHome } = useMember();
  const homeId = selectedHome?.home_id;
  const [rows, setRows] = useState<ReservationReturn[] | null>(null);

  useEffect(() => {
    if (!homeId) return;
    let cancelled = false;
    memberReservationService
      .listMyReservations({ homeId, scope: 'upcoming', perPage: SHOWN })
      .then(({ data }) => {
        if (!cancelled) setRows(data.reservations);
      })
      .catch(() => {
        if (!cancelled) setRows(null);
      });
    return () => {
      cancelled = true;
    };
  }, [homeId]);

  if (!homeId || rows === null) return null;

  return (
    <section>
      <div className="mb-3 flex items-baseline justify-between gap-2">
        <Subheading>Upcoming reservations</Subheading>
        <Link
          to={rows.length ? '/reservations' : '/amenities'}
          className="text-sm text-sky-700 hover:underline dark:text-sky-400"
        >
          {rows.length ? 'See all' : 'Book an amenity'}
        </Link>
      </div>
      {rows.length === 0 ? (
        <Text className="text-sm">Nothing booked.</Text>
      ) : (
        <ul className="space-y-2">
          {rows.map((r) => (
            <ReservationRow key={r.id} reservation={r} />
          ))}
        </ul>
      )}
    </section>
  );
};

export default UpcomingReservationsCard;
